<template>
  <email-opt-in-input :key="fieldKey" :entity-name="entityName" :input-id="inputId" :input-name="inputName" :validation-errors="validationErrors"
                      :email-opt-in-type-data="fieldData" :email-opt-in-type-field-name-override="emailOptInTypeFieldNameOverride"
                      :label="label" :show-label="showLabel" @changed="changed" @focus="$emit('focus')" />
</template>

<script>
import EmailOptInInput from '@/components/inputs/email-opt-in-input'
import { mapGetters } from 'vuex'

export default {
  components: { EmailOptInInput },

  props: {
    emailOptInTypeFieldNameOverride: {
      type: String,
      required: false
    },

    entityName: {
      type: String,
      required: true
    },

    globalSubscriptionData: {
      type: Object,
      required: false
    },

    inputId: {
      type: String,
      required: false,
      default: null
    },

    inputName: {
      type: String,
      required: false,
      default: null
    },

    label: {
      type: String,
      required: false
    },

    regularData: {
      type: Object,
      required: true
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },

    validationErrors: {
      type: Array,
      required: false
    }
  },

  emits: ['changed', 'focus'],

  computed: {
    ...mapGetters(['isSubscribedInCrm']),

    fieldData() {
      return this.isSubscribedInCrm ? this.globalSubscriptionData : this.regularData
    },

    // We use a separate :key so that when it changes, Vue will re-initialize the component.
    // This ensures it will re-do the data setup stuff with the new emailOptInTypeData prop.
    fieldKey() {
      return this.isSubscribedInCrm ? 'global-subscription-key' : 'regular-key'
    }
  },

  methods: {
    changed(value) {
      this.$emit('changed', value)
    }
  }
}
</script>
